// Handing a captured frame to the browser as a download.
//
// THE PAGE IS NOT RESPONSIBLE FOR THE ANCHOR, and it used to be. onScreenShot
// read document.getElementById('take-snapshot') and set .href on whatever came
// back - so on every page that did not happen to render that element it threw
// "Cannot set properties of null (setting 'href')". The frame was captured
// FIRST and then thrown away by the exception, so nothing on screen changed and
// there was no message: pressing S looked like a key that was not wired.
//
// Seven of the nine things that render ViewerToolbar were missing the anchor
// (ModelViewer, TimelineViewer, AlignSheetPage, SocketViewer, IssueModelCanvas,
// Viewer3d, ModelPane); only Tracking/ModelStage and Issue/CreateIssuePage had
// it. And because TOOLS defaults to every key, all nine SHOW the camera button -
// so on those seven the button and the S shortcut died together while grid,
// measure, section, isolate and home kept working beside them. That is why the
// owner reported it as "some buttons on the viewer" (2026-09-25) rather than as
// the viewer being broken.
//
// CreateIssuePage already created the element when it was missing. That
// workaround is what hid this for the two pages that worked, and it is the
// reason to fix it HERE: one owner, no page has to know, and the per-page
// anchors become redundant rather than required.
//
// Its own file so it is testable without standing up a viewer, the same reason
// keyGuard is its own file.

export const SNAPSHOT_ANCHOR_ID = 'take-snapshot';

// Returns true when the download was handed over, false when it could not be -
// never throws, because a failed screenshot must not take the render loop with
// it. A caller that wants to say something to the person can use the result.
export function saveDataUrl(dataUrl, filename, doc = typeof document !== 'undefined' ? document : null) {
  if (!dataUrl || !doc || typeof doc.createElement !== 'function') return false;
  let link = null;
  try {
    link = typeof doc.getElementById === 'function' ? doc.getElementById(SNAPSHOT_ANCHOR_ID) : null;
  } catch (e) { link = null; }

  // A page that already provides the anchor keeps using it, so nothing about
  // the two pages that work today changes.
  let borrowed = !!link;
  if (!link) {
    if (!doc.body || typeof doc.body.appendChild !== 'function') return false;
    link = doc.createElement('a');
    link.id = SNAPSHOT_ANCHOR_ID;
    link.style.display = 'none';
    doc.body.appendChild(link);
  }

  try {
    link.href = dataUrl;
    link.download = filename;
    if (typeof link.click === 'function') link.click();
    return true;
  } catch (e) {
    return false;
  } finally {
    // Only clean up what we made. Removing a page's own anchor would break the
    // NEXT press on the two pages that render one.
    if (!borrowed) {
      try { if (link.parentNode) link.parentNode.removeChild(link); } catch (e) { /* best effort */ }
    }
  }
}

export default saveDataUrl;
